import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminBoxSaleStatus } from '../../enums/admin-box-sale-status';
import { AdminBoxSaleStatusPipe } from '../../pipes/admin-box-sale-status.pipe';

@Component({
  selector: 'app-admin-box-sale-status',
  imports: [CommonModule, AdminBoxSaleStatusPipe],
  templateUrl: './admin-box-sale-status.component.html',
  styleUrl: './admin-box-sale-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxSaleStatusComponent {
  public readonly status = input.required<AdminBoxSaleStatus>();
}
